export default "__VITE_ASSET__kVON6WM9__"